import { useEffect } from 'react';

import { CloseModalButton } from '@wac-web/components/product-demos/jsw-interactive-board/src/components/close-modal-button';
import { FormattedMessage } from 'react-intl';

import Heading from '@atlaskit/heading';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { ModalHeader } from '@atlaskit/modal-dialog';

import { useFastshiftSelector } from '@/state';

import { useRelationshipsAnalytics } from '../../hooks';
import { isSupportRequestOpen } from '../../utils';

import { messages } from './messages';
import { RequestAssistanceModalEmpty } from './request-assistance-modal-empty';
import { FastshiftAssistanceModalForm } from './request-assistance-modal-form';
import { RequestAssistanceModalLoader } from './request-assistance-modal-loader';

export const RequestAssistanceModal = ({
	isModalOpen,
	setIsModalOpen,
}: {
	isModalOpen: boolean;
	setIsModalOpen: (isModalOpen: boolean) => void;
}) => {
	const { data: supportRequestsData, pending: isSupportRequestsLoading } = useFastshiftSelector(
		(state) => state.supportRequests,
	);

	const { sendRequestAssistanceModalDisplayedTrackEvent } = useRelationshipsAnalytics();

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const openTicketCount = (supportRequestsData ?? []).filter((request) =>
		isSupportRequestOpen(request.status),
	).length;

	// Track modal displayed event when modal opens
	useEffect(() => {
		if (isModalOpen && !isSupportRequestsLoading) {
			const isEmpty = openTicketCount === 0;
			sendRequestAssistanceModalDisplayedTrackEvent(isEmpty, openTicketCount);
		}
	}, [
		isModalOpen,
		isSupportRequestsLoading,
		openTicketCount,
		sendRequestAssistanceModalDisplayedTrackEvent,
	]);

	return (
		<>
			<ModalTransition>
				{isModalOpen && (
					<Modal onClose={handleCloseModal} testId="request-assistance-modal">
						<ModalHeader>
							<Heading size="medium">
								<FormattedMessage {...messages.requestAssistanceModalTitle} />
							</Heading>

							<CloseModalButton onCloseClick={handleCloseModal} />
						</ModalHeader>
						{isSupportRequestsLoading ? (
							<RequestAssistanceModalLoader />
						) : openTicketCount > 0 ? (
							<FastshiftAssistanceModalForm
								handleCloseModal={handleCloseModal}
								supportRequests={supportRequestsData ?? []}
								isSupportRequestsLoading={isSupportRequestsLoading}
							/>
						) : (
							<RequestAssistanceModalEmpty handleCloseModal={handleCloseModal} />
						)}
					</Modal>
				)}
			</ModalTransition>
		</>
	);
};
